import { useRef, useEffect } from 'react';
import { Inspector } from 'fsm';
import { LowLevelAuthFlowMachineEvent } from '../LowLevelAuthFlowMachineDefinition';
import { LowLevelCustomAuthError } from '../LowLevelAuthFlowMachineDefinition';

export function useAuthFlowInspector<
  AuthResponse,
  AuthError extends LowLevelCustomAuthError = never,
>(debug: boolean, appName: string) {
  const inspectorRef = useRef<Inspector<
    LowLevelAuthFlowMachineEvent<AuthResponse, AuthError>
  > | null>(null);

  // eslint-disable-next-line react-hooks/refs
  if (debug && !inspectorRef.current) {
    inspectorRef.current = new Inspector<
      LowLevelAuthFlowMachineEvent<AuthResponse, AuthError>
    >({
      name: `AuthFlowMachine-${appName}`,
      maxTimelineSize: 200,
      initialStatus: 'running',
    });
  }

  useEffect(() => {
    if (debug && inspectorRef.current) {
      const timeline = inspectorRef.current.getTimeline();

      console.log(
        `[DEBUG ${appName} Auth Flow Inspector] Timeline:`,
        new Date().toUTCString(),
        timeline
      );
    }
    // eslint-disable-next-line react-hooks/refs
  }, [debug, appName, inspectorRef.current?.timeline.length]);

  // eslint-disable-next-line react-hooks/refs
  return inspectorRef.current;
}
